// Dashboard Getters

export const toggleSidebarSubMenu = state => {
  return state.toggleSidebarSubMenu
}

export const sidebarLinks = state => {
  return state.sidebarLinks
}

export const sidebarSubLinks = state => {
  return state.sidebarSubLinks
}

export const currentSubLinks = state => {
  return state.currentSubLinks
}

export const sidebarWidth = state => {
  return state.sidebarWidth
}

export const getAppBarTitle = state => {
  return state.appBarTitle
}

export const getCashBalance = state => {
  return state.cashBalance
}

export const getAllBalance = state => {
  return state.allBalance
}
